import { render } from "./IconPing.vue?vue&type=template&id=20d1dccb&scoped=true&ts=true"
import script from "./IconPing.vue?vue&type=script&lang=ts"
export * from "./IconPing.vue?vue&type=script&lang=ts"

import "./IconPing.vue?vue&type=style&index=0&id=20d1dccb&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-20d1dccb"]])

export default __exports__